import React from 'react'
import { Container } from '@mui/material'
import styled from 'styled-components'
import AchievementMobile from '../../assets/Success-illustration.svg'
import { Link } from 'react-router-dom'

const Background = styled.div`
  position: relative;
  width: 100%;
  background: #25233B;
  display: flex;
  background: #FFFFFF;
  margin-top: 19.65px;
  @media (min-width: 0px) and (max-width: 600px) {
       background: #FFFFFF;
       margin-top: 0px;
  }
  @media (min-width: 601px) and (max-width: 900px) {
    background: #FFFFFF;
    margin-top: 0px;

}
`

const TextHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: inherit;
  @media (min-width: 0px) and (max-width: 420px) {
        display: block;
        margin-left: 0px;
        margin-right: 0px;
        padding-left: 0px;
        padding-top: 0px;
  }
  @media (min-width: 421px) and (max-width: 900px){
    padding-left: 0px;
  }

`

const Message = styled.div`
    font-family: 'AeonikPro-Medium';
    font-style: normal;
    text-align: center;
    color: #ffff;
    position: absolute;
    top: -100px;
    font-weight: 500;
    font-size: 24px;
    width: 156px;
    height: 72px;
    @media (min-width: 0px) and (max-width: 600px) {
      top: -82px;
      font-size: 18px;
      line-height: 26px;
      width: 129px;
      left: 78px;
    }
`

const SubScript = styled.div`
    font-family: 'AeonikPro-Medium';
    font-style: normal;
    text-align: center;
    color: #25223B;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    @media (min-width: 0px) and (max-width: 600px) {
        font-size: 16px;
        line-height: 24px;
        margin-top: 16px;
    };
    @media (min-width: 601px) and (max-width: 900px) {
      font-size: 16px;
      line-height: 24px;
      margin-top: 16px;
      width:326px;
  }
`

const BackToLink = styled.div`
  display: flex;
  justify-content: center;
  font-family: 'AeonikPro-Regular';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-top: 25px;
  @media (min-width: 0px) and (max-width: 900px) {
    margin: 36px auto 0px;
    font-size: 14px;
  }
`

const AchievementMobileImg = styled.img.attrs(() => ({
  src: AchievementMobile
}))`
  display: block;
  margin: auto;
  height: 370px;
  width: 375.64px;
   @media (min-width: 0px) and (max-width: 600px) {
     width: 100%;
     height: 315.86px;
   }
   @media (min-width: 601px) and (max-width: 900px) {

  }
`

const containerStyles = {
  margin: '124px auto 0px',
  padding: '0px',
  width: 'auto',
  '@media (min-width: 0px) and (max-width: 420px)': {
    width: '90%',
    padding: '0px'
  }
}

interface IProps{
  isDemo : boolean
}

const ContactSuccess = (props: IProps) => {
  return (
    <Container sx={containerStyles}>

      <AchievementMobileImg/>
      <Background>
       <TextHolder>
          <Message>Thank you for your interest. </Message>
          {props.isDemo && <SubScript>We’ll reach out soon to set up your demo.</SubScript>}
          {!props.isDemo && <SubScript>You’ll hear back from us soon.</SubScript>}
        </TextHolder>
      </Background>
      <BackToLink>
        <Link to={'/'} style={{ textDecoration: 'none', fontFamily: 'AeonikPro-Medium', fontStyle: 'normal', fontWeight: '400', lineHeight: '30px', textAlign: 'center', color: '#FF6B18' }}>&lt; Back </Link>
      </BackToLink>
    </Container>
  )
}

export default ContactSuccess
